import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  Condition,
  Campaign,
} from "@dndModels";

import { makeStyles } from "@utilities/theme_utilities";

import StringBox from "@components/input/strings/StringBox";
import ButtonBox from "@components/input/buttons/ButtonBox";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";

interface Props {
  campaign: Campaign;
  log_it?: boolean;
  cond: Condition; 
  onSelect: (count: number) => void;
}

// const api = DandDAPI.getInstance();
// const char_util = DandDCharacterUtilities.getInstance();

export default function CampaignSelectCondition({
  campaign,
  log_it,
  cond,
  onSelect,
}: Props) {
  if (log_it) {
    debugger;
  }
  const [use_count, setUseCount] = useState(1);
  const [expanded, setExpanded] = useState(false);

  const useRowStyles = makeStyles()((theme) => {
    return ({
      root: {
        backgroundColor: theme.palette.secondary.main,
        border: "1px solid"
      },
    });
  });
  
  const { classes, cx } = useRowStyles();
  
  let expanded_content: any = null;
  if (expanded) {
    expanded_content = (
      <Grid
        container
        spacing={0}
        direction="row"
        style={{ border: "1px solid", padding: "4px", backgroundColor: "black" }}
        size={{
          xs: 12
        }}>
        <Grid
          size={{
            xs: 12
          }}>
          <DisplayStringWithReplacements display_string={cond.description} />
        </Grid>
        <Grid
          style={{ margin: "auto" }}
          size={{
            xs: 8
          }}>
          { cond.max_level > 1 && 
            <StringBox 
              name="Level"
              value={`${use_count}`}
              type="number"
              onChange={(value: string) => {
                const new_count = Math.floor(+value);
                if (!isNaN(new_count)) {
                  setUseCount(new_count);
                }
              }}
            />
          }
        </Grid>
        <Grid
          style={{ margin: "auto" }}
          size={{
            xs: 2
          }}>
          <ButtonBox
            name={`Add${ use_count > 1 ? ` (${use_count})` : ""}`}
            small
            onClick={() => {
              // debugger;
              onSelect(use_count);
            }}
          />
        </Grid>
      </Grid>
    );
  }

  return (
    <>
      <Grid container spacing={0} direction="row"
        className={cx(classes.root, "padded")}>
        <Grid
          className="clickable"
          onClick={() => { setExpanded(!expanded); }}
          size={{
            xs: 10
          }}>
          { cond.name }
        </Grid>
        <Grid
          size={{
            xs: 2
          }}>
          <Grid container spacing={0} direction="row">
            <Grid
              style={{ margin: "auto" }}
              size={{
                xs: 12
              }}>
              <ButtonBox
                name={`Add`}
                small
                onClick={() => {
                  // debugger;
                  onSelect(1);
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        { expanded_content }
      </Grid>
    </>
  );
}
